import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { Recall } from "@/Common/Api/Communications/Dto/Recall";
import { RecallCommunication } from "@/Common/Api/Communications/Dto/RecallCommunication";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { SingleSelectAutoComplete } from "@/Common/Components/Inputs/SingleSelectAutocomplete";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { CommunicationsHelper } from "@/Communications/Helpers/CommunicationsHelper";
import { RecallTableItem } from "@/Communications/Models/Recalls/RecallTableItems";
import { CommunicationsTab_OptimizedV2 } from "./CommunicationsTab_OptimizedV2";

interface IRecallNotesPopupProps {
    controlId: string;
    notes: RecallCommunication[];
    recall: RecallTableItem;

    leftPosition: number;
    topPosition: number;

    removeActiveClassFromTable: () => void;
    onClose: () => void;
    onResize?: () => void;
    loadRecallRef?: () => void;
}

class RecallNotesPopupState {
    public statuses: FlatLookupView[];
    public selectedStatusId: string;
    public text: string;
    public topPosition: number;
    public dueDate: Date;
    public description: string;
    public selectedDescriptions: KeyValuePair<string, string>[];
    public recall: Recall;

    public static getDefault(props: IRecallNotesPopupProps): RecallNotesPopupState {
        const state = new RecallNotesPopupState();
        state.statuses = CommunicationsHelper.GetRecallStatusesLookupsFromCache();
        state.selectedStatusId = null;
        state.text = null;
        state.topPosition = props.topPosition;
        state.recall = props.recall.Model;
        state.dueDate = new Date(state.recall.DueDate);
        state.description = state.recall.Type;
        state.selectedDescriptions = [];

        return state;
    }
}

class RecallNotesPopup extends BaseReactComponent<IRecallNotesPopupProps, RecallNotesPopupState> {
    private controlId: string;
    public constructor(props: IRecallNotesPopupProps) {
        super(props);
        this.controlId = props.controlId || sessionStore.newId().toString();
        this.state = RecallNotesPopupState.getDefault(props);
    }

    public componentDidMount(): void {
        super.setOverlay("CommunicationsRecallNotesPopup", { transparent: true });

        this.moveThePopupAboveCommunicationTabFooter();

        window.addEventListener("resize", () => this.handleResized());
        const elem = document.getElementById("memo_doctb");
        autosize(elem);
    }

    public componentDidUpdate(nextProps: IRecallNotesPopupProps): void {
        if (this.props.notes !== nextProps.notes)
            this.moveThePopupAboveCommunicationTabFooter();
    }

    public moveThePopupAboveCommunicationTabFooter(): void {
        // Check if we're below Rendering belong the Footer
        const footer = $("." + CommunicationsTab_OptimizedV2.footerCSS);
        if (footer) {
            const elem = $(`#${this.controlId}`);
            const elemTop = this.props.topPosition;
            const elemBottom = elemTop + elem.height();
            if (elemBottom > footer.position().top)
                this.mutateState(s => s.topPosition = this.props.topPosition - (elemBottom - footer.position().top));
        }
    }

    public render(): JSX.Element {
        const hasDescription = this.state.description.trim().length > 0;

        const style: React.CSSProperties = {
            position: "absolute",
            left: this.props.leftPosition + "px",
            top: this.state.topPosition + "px"
        };

        return (
            <div key={this.props.controlId} id={this.props.controlId} data-dropdown-content className="notes-modal" aria-hidden="false" style={style} aria-autoclose="false">
                <div className="notes-dropdown-content" data-cy="recallNotesPopup">
                    <div>
                        <h4 className="thin-font">{cacheStore.GetString("DescriptionLabel").toUpperCase()}</h4>
                        <div>
                            <SingleSelectAutoComplete
                                id={this.state.recall.Id}
                                valid={hasDescription}
                                useblurevent
                                componentId="recall_edit_description"
                                selectedItems={this.state.selectedDescriptions.toImmutable()}
                                displayedTextValue={this.state.description}
                                onSelecting={kvp => this.mutateState(s => s.description = kvp.Value)}
                                focusOnLoad={false}
                                onChangeText={text => this.mutateState(s => s.description = text)}
                                closeDropDownAfterSelection
                            />
                        </div>
                    </div>

                    <div className="recall-note-paddingtop">
                        <h4 className="thin-font">{cacheStore.GetString("DueDateLabel").toUpperCase()}</h4>
                        <div>
                            <DateSelector
                                id="task_edit_duedate_note"
                                cssClass=""
                                date={this.state.dueDate}
                                onChangeCallback={date => this.mutateState(s => s.dueDate = date)}
                                dateFormat="yyyy/MM/dd"
                                disabled={false}
                                toDayEnabled
                            />
                        </div>
                    </div>

                    <div className="recall-note-paddingtop">
                        <h4 className="thin-font">{cacheStore.GetString("StatusDLabel").toUpperCase()}</h4>
                        <select onChange={(e: any) => this.handleStatusChanged(e.target.value)} className="form-control myle-control" value={this.selectedStatusId}>
                            <option key="empty" value="" />
                            {this.state.statuses.map(s =>
                                <option key={s.LookupID} value={s.LookupID}> {cacheStore.GetLocalizedValueByLookupId(s.LookupID)}</option>
                            )}
                        </select>
                    </div>
                    <div className="recall-note-paddingtop">
                        <h4 className="thin-font">{cacheStore.GetString("AddNoteLabel").toUpperCase()}</h4>
                        <textarea
                            style={{ maxHeight: "90px" }}
                            className="form-control"
                            data-cy="recallNotesPopup-note"
                            value={this.state.text || ""}
                            id="memo_doctb"
                            onChange={(e: any) => this.handleTextChanged(e.target.value)}
                            rows={4}
                            autoFocus
                        />
                    </div>
                    {!isArrayNullOrUndefinedOrEmpty(this.props.notes) && (
                        <div className="recall-note-paddingtop">
                            <h4 className="thin-font">{cacheStore.GetString("CommunicationHistoryLabel").toUpperCase()}</h4>

                            <div className="scroll-limit">
                                {this.props.notes.map(note => {
                                    const person = cacheStore.GetCliniciansPersonsByContactId(note.ContactId);
                                    return (
                                        <div key={note.Id} className="notes-collection-item">
                                            <div className="memo-header">
                                                <strong>
                                                    <span>{person.Name}</span>
                                                    <span className="separator">{cacheStore.GetString("OnLabel")}</span>
                                                    <span>{moment(note.DateCreated).format("YYYY-MM-DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(note.DateCreated).format("hh:mm a")}</span>
                                                    {note.StateLookupId && <span className="separator">|</span>}
                                                    <span className="logo-color">{cacheStore.GetLocalizedValueByLookupId(note.StateLookupId)}</span>
                                                </strong>

                                            </div>
                                            <div className="note-container" style={{ marginTop: "5px" }}>
                                                {JSXHelper.BreakStringIntoParagraphs(note.Notes)}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>

                <div className="notes-content-footer text-right">
                    <button className="btn btn-default push-right-5" data-cy="recallNotesPopup-cancel" onClick={() => this.props.onClose()}>{cacheStore.GetString("CancelLabel")}</button>
                    <button className="btn btn-primary push-right-5" data-cy="recallNotesPopup-submit" disabled={!hasDescription} onClick={() => this.handleSubmitted(false)}>{cacheStore.GetString("NoteSubmitLabel")}</button>
                    {!this.props.recall.Model.IsCompleted &&
                        <button className="btn btn-primary" disabled={!hasDescription} onClick={() => this.handleSubmitted(true)}>{cacheStore.GetString("MarkRecallAsCompletedLabel")}</button>
                    }
                </div>
            </div>
        );
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
        this.props.removeActiveClassFromTable();
        window.removeEventListener("resize", this.handleResized);
        const elem = document.getElementById("memo_doctb");
        const event = document.createEvent("Event");
        event.initEvent("autosize:destroy", true, false);
        elem.dispatchEvent(event);
    }

    private get selectedStatusId(): string {
        return !IsNullOrUndefined(this.state.selectedStatusId)
            ? this.state.selectedStatusId
            : this.props.recall.RecallCommunicationStatusLookupId;
    }

    private handleResized(): void {
        this.props.onResize && this.props.onResize();
    }

    private handleStatusChanged(id: string): void {
        this.mutateState(s => s.selectedStatusId = id);
    }

    private handleTextChanged(text: string): void {
        this.mutateState(s => s.text = text);
    }

    private handleSubmitted(setRecallToComplete: boolean): void {
        const recallCom = new RecallCommunication();
        recallCom.Notes = this.state.text;
        recallCom.StateLookupId = this.state.selectedStatusId;
        recallCom.RecallId = this.props.recall.Id;
        let recall = this.state.recall;
        recall.Type = this.state.description;
        recall.DueDate = this.state.dueDate ? moment(this.state.dueDate).format("YYYY-MM-DD") : null;

        Client.Postv2(
            ServerOperations.Server.Myle_SaveRecallCommunication,
            {
                Recall: recall,
                RecallCommunication: recallCom,
                SetRecallToComplete: setRecallToComplete,
                ReturnSavedObject: true
            },
            response => {
                if (response.IsDone) {
                    this.props.loadRecallRef && this.props.loadRecallRef();
                    this.props.onClose();
                }
            }
        );
    }
}

export { RecallNotesPopup };
